import React, { ChangeEvent, CompositionEvent } from "react";

// 以下 3 つは .jsx のため TS から見た型宣言ファイルが無い。プロジェクト方針として
// `.tsx` 化されるまで個別に @ts-ignore で抑制する（他の TSX 利用箇所と同じ扱い）。
// @ts-ignore
import GuideImage from "../../../components/guide-image/GuideImage";
// @ts-ignore
import TitleBlock from "../../../components/block/TitleBlock";
import Input from "../../../components/form-item/Input";
// @ts-ignore
import Autofill from "../../../components/autofill/AutoFill";

interface ProjectCodeNameInputProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * プロジェクト作成ウィザード用のコードネーム入力。
 * 編集用 ProjectCodeName は projectId 必須で PATCH オートセーブする実装のため、
 * 作成フローでは projectId なしで親 state にのみ反映する軽量版を使う。
 */
const ProjectCodeNameInput: React.FC<ProjectCodeNameInputProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  // IME 確定時、ブラウザ実装によっては `change` より先に `compositionend` が
  // 発火するため、確定後の値を確実に親へ伝えるために onCompositionEnd でも
  // onChange を呼ぶ。
  const handleCompositionEnd = (e: CompositionEvent<HTMLInputElement>) => {
    onChange((e.target as HTMLInputElement).value);
  };

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="コードネーム"
        description="プロジェクトのコードネームを設定しましょう。関係者だけで使う秘密の呼び名として、プロジェクトを安全に識別するために使います。"
      />
      <GuideImage name="project_codename" />
      <Autofill
        group="codeName"
        nowrap={false}
        onSelectContent={onChange}
      />
      <Input
        type="text"
        label="コードネーム"
        option="required"
        placeholder="Apollo"
        width="100%"
        maxlength={255}
        name="code_name"
        value={value}
        onChange={handleChange}
        onCompositionEnd={handleCompositionEnd}
      />
    </div>
  );
};

export default ProjectCodeNameInput;
